

<div fxLayout="column" fxLayoutGap="8px">
   <input [attr.guide]="'common-file-upload-pdf-inp-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" type="file" #myInput hidden ng2FileSelect [uploader]="uploader"/>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <button [attr.guide]="'common-file-upload-pdf-choose-1' + '__' + sanitizeUrl(url)" type="button" mat-raised-button (click)="myInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            <span>Choose File</span>
        </button>
        <span class="chosen-file" fxFlex>
            {{ uploader?.queue?.length ? (uploader.queue[0]?.file?.name | slice:0:60) : 'No file chosen' }}
        </span>

        <button [attr.guide]="'common-file-upload-pdf-btn-2' + '__' + sanitizeUrl(url)" [disabled]="!uploader?.queue?.length || text !='Upload all'" (click)="upload()" type="button" mat-raised-button color="primary">
            <mat-icon>cloud_upload</mat-icon>
            <span>{{text}}</span>
            <mat-icon *ngIf="text !='Upload all'">
                <mat-spinner color="primary" diameter="20"></mat-spinner>
            </mat-icon>
        </button>
    </div>
</div>
